<template>
  <section class="orders">
    <main :class="{ 'expand-main': isMenuCollapse, main: (!fromClient && !fromAtRiskAccounts) }">
      <div class="row">
        <template v-if="!fromAtRiskAccounts">
        <h4 class="ml-5">{{ getTittle() }}</h4>
        <div class="col-md-12">
          <!-- Banner to orders with status preparing and verified -->
          <div v-if="!hasPermissions('adminClients')">
            <div
              class="banner my-2"
              v-for="(order_verified, i) in ordersPreparingAndVerified"
              :key="i"
            >
              <span class="banner-message">
                {{
                  $t("lang.orders.verified_banner", {
                    name: order_verified.name,
                    date: order_verified.launch_date_campaign,
                  })
                }}
                <a
                  target="_blank"
                  :href="$t('lang.orders.verified_banner_link')"
                >
                  ( {{ $t("lang.orders.name_link_banner") }} )
                </a>
              </span>
            </div>
          </div>

          <!-- Banner to orders with status preparing and not verified -->
          <div class="my-3" v-if="!hasPermissions('adminClients')">
            <div
              class="banner my-2"
              v-for="(order_no_verified, i) in ordersPreparingAndNotVerified"
              :key="i"
            >
              <span class="banner-message">
                {{
                  $t("lang.orders.no_verified_banner", {
                    name: order_no_verified.name,
                  })
                }}
                <a
                  target="_blank"
                  :href="$t('lang.orders.no_verified_banner_link')"
                >
                  ( {{ $t("lang.orders.name_link_banner") }} )
                </a>
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card m-2 p-2" v-if="currentUser.role_id != 4">
            <div v-if="isOliverSale || hasPermissions('superAdmin')">
              <div class="row float-left ml-0 pl-0">
                <div class="col-md-3 w-25">
                  <span
                    class="loadingres spinner-border loading-spinner ml-2"
                    v-if="userOliverSales.length <= 1 && !waitingchoise"
                  ></span>
                  <IndustrySearch
                    :isDisabled="userOliverSales.length <= 1"
                    :option_list="userOliverSales"
                    :default_values="userOliverSale"
                    :key="key"
                    :multiple="false"
                    @selected="selectOliverSale"
                  />
                </div>
                <div class="col-md-9 w-75" v-if="!waitingchoise">
                  <span class="ml-2">{{ $t("lang.label.orderby") }}:</span>
                  <span class="mx-2">
                    <select
                      v-model="orderBy"
                      @change="updateOrder"
                      class="form-control"
                      :disabled="loading"
                    >
                      <option value="0">Option Default</option>
                      <option value="cold_meeting_rate">
                        {{ $t("lang.column.header_booker_cold_mt") }}
                      </option>
                      <option value="total_cold_tasks_done">
                        {{ $t("lang.column.cold_tasks_done") }}
                      </option>
                      <option value="lowest_available_contacts">
                        {{ $t("lang.label.lowest_available_contacts") }}                        
                      </option>
                    </select>
                  </span>
                  <span class="mx-2">
                    <select
                      v-if="orderBy != '0'"
                      v-model="orderDirection"
                      @change="updateOrder"
                      class="form-control"
                      :disabled="loading"
                    >
                      <option value="asc">Asc</option>
                      <option value="desc">Desc</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>

            <!-- Filter -->
            <div class="w-100">
              <div
                class="mt-2 float-left"
                :class="{ 'orders-filter-embedded-client': fromClient }"
              >
                <FilterSystem
                  class="float-left"
                  :columns="campaignsColumns"
                  :reset="resetFilterSystem"
                  :sort="sort"
                  :dir="dir"
                  :filterSystem="filtersSystem"
                  :filterOldQuery="oldQuery"
                  :menuPosition="fromClient ? 'left' : 'right'"
                  :key="filterkey"
                  @callApi="filter($event)"
                /> 
              </div>

              <!-- Button New Order -->
              <div class="px-4 float-right">
                <div
                  id="neworder"
                  class="top-area-opp mt-2 float-right d-none d-sm-block"
                >
                  <button
                    class="w-100 btn btn-sm btn-primary themed-button effect-btn"
                    @click="addOrder"
                    v-if="
                      hasPermissions('adminClients') ||
                      hasPermissions('billing')
                    "
                    type="submit"
                  >
                    <i class="icon-plus1"></i>
                    {{ $t("lang.button.neworder") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 text-right pr-5"
          v-if="!loading && !showEmptyImage && bookerAvailable && currentUser.role_id != 4"
        >
          Available Bookers: {{ bookerAvailable }}
        </div>

      </template>

        <div class="col-md-12">
          <div class="m-1 p-1">
            <template v-if="!fromAtRiskAccounts">
            <!-- Tabs -->
            <Tabs
              v-if="this.language_id == 0"
              :tabSelected="typelist"
              :tabs="selectTabs"
              :disabled="loading"
              @change="loadOrders($event)"
            />

            <Tabs
              class="mt-3"
              v-if="
                typelist == 1 &&
                (typelistPreparing == 6 ||
                  typelistPreparing == 7 ||
                  typelistPreparing == 8 ||
                  typelistPreparing == 9)
              "
              :tabSelected="typelistPreparing"
              :tabs="tabPreparing"
              :disabled="loading"
              @change="loadOrders($event)"
            />

            <div
              class="d-flex flex-row justify-content-center py-0 my-0 w-100 pt-4"
              v-if="waitingchoise"
            >
              <div class="col-lg-12 pt-2 text-center py-0">
                <img
                  src="@/assets/images/search-oliver3.png"
                  class="rounded mx-auto d-block py-0"
                  width="180px"
                />
              </div>
            </div>

            </template>

            <!-- Table (list orders) + Paginador -->
            <div class="w-100 mt-2" v-if="!waitingchoise">
              <!-- Results -->
              <div v-if="!loading" class="">
                <small>
                  {{ $t("lang.label.results") }}:
                  <small
                    v-if="total == undefined"
                    class="ml-1 text-primary mr-4"
                  >
                    {{ $t("lang.search.calculating") }}...
                  </small>
                  <strong v-else>{{ total }}</strong>
                </small>
              </div>

              <template v-if="!fromAtRiskAccounts">
                <div v-if="!loading" class="">
                  <StatsOrder :orderId="'1'" :stats="calculateStats" />
                </div>
              

                <div v-if="currentUser.role_id == 1 && !loading" class="">
                  <small class="mx-1">
                    <i class="icon-mail text-secondary"></i> G.M:
                    <strong
                      class="ml-2"
                      v-if="
                        calculateStats.global_margin &&
                        calculateStats.global_margin !== 'NaN'
                      "
                    >
                      {{ calculateStats.global_margin }}%
                    </strong>
                    <strong class="ml-2" v-else>-</strong>
                  </small>
                  <small class="ml-3">
                    <i class="icon-mail text-danger"></i> Gmail:
                    <strong
                      class="ml-2"
                      v-if="
                        calculateStats.spam_check_gmail &&
                        calculateStats.spam_check_gmail !== 'NaN'
                      "
                    >
                      {{ calculateStats.spam_check_gmail }}%
                    </strong>
                    <strong class="ml-2" v-else>-</strong>
                  </small>
                  <small class="ml-3">
                    <i class="icon-mail text-primary"></i> Ews:
                    <strong
                      class="ml-2"
                      v-if="
                        calculateStats.spam_check_ews &&
                        calculateStats.spam_check_ews !== 'NaN'
                      "
                    >
                      {{ calculateStats.spam_check_ews }}%
                    </strong>
                    <strong class="ml-2" v-else>-</strong>
                  </small>
                </div>

              </template>

              <LoadingSpinner v-if="loading" />

              <!-- Botón para expandir columnas -->
              <div class="col-12 text-right mb-2" v-if="!loading && !showEmptyImage && currentUser.role_id != 4">
                <button 
                  @click="toggleExpandedColumns" 
                  class="btn btn-outline-primary btn-sm"
                  :disabled="fieldsLoading"
                >
                  <i class="icon" :class="expandedColumns ? 'icon-minus' : 'icon-plus'"></i>
                  {{ expandedColumns ? $t('lang.column.hide_advanced_columns') : $t('lang.column.show_more_columns') }}
                </button>
              </div>

              <div :class="fromClient ? 'table-responsive mx-0 mt-2' : 'mx-0 mt-2'">
                <Table
                  v-if="!loading && !showEmptyImage"
                  class="mx-2 w-100"
                  :headers="allHeaders"
                  :cols="allColumns"
                  :data="orders"
                  :checkbox="false"
                  :notselect="true"
                  :model="model"
                  :fieldsLoading="fieldsLoading"
                  :key="captainkey"
                  @editOrder="editOrder"
                  @openTarget="openTarget"
                  @openClient="openClient"
                  @openWebsite="openWebsite"
                  @getAvailableContacts="getAvailableContacts"
                  @openTargetSituation="openTargetSituation"
                />
              </div>

              <div class="col-12 text-center my-4" v-if="!fromAtRiskAccounts">
                <div class="d-inline">
                  <Pagination
                    v-if="!loading && !showEmptyImage"
                    :total="total"
                    :totalpage="this.orders.length"
                    :model="model"
                    :limit="false"
                    :color="'primary'"
                    @changePage="changePage"
                    key="paginationkey"
                  />
                </div>
              </div>

              <div class="w-100 text-center pt-5" v-if="showEmptyImage">
                <img src="@/assets/images/launch.png" class="" />
                <div class="mt-3 text-center">
                  <span
                    class="font-weight-light ft-1-5 text-center text-secondary"
                  >
                    {{ $t("lang.label.therearenoordersatthemoment") }}
                  </span>
                </div>
                <div
                  class="mt-3 text-center"
                  v-if="!hasPermissions('adminClients')"
                >
                  <div class="mr-2 d-inline">
                    <button
                      id="newcampaign"
                      class="btn btn-sm btn-primary themed-button effect-btn"
                      @click="addOrder"
                      type="submit"
                    >
                      <i class="icon-plus1"></i>
                      {{ $t("lang.button.neworder") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Modal v-if="isAdmin" name="target-situation-modal" :size="'75'" :scrollable="true">
      <div class="p-4">
        <h5 v-if="situationTarget" class="mb-3">
          {{ situationTarget.target_name }}
          <small class="text-muted">#{{ situationTarget.target_id }}</small>
        </h5>
        <TargetCampaignHealthPanel
          v-if="situationTarget"
          :key="situationTarget.target_id"
          :target_id="situationTarget.target_id"
          :show-button="false"
          :auto-load="true"
        />
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, usersService, clientsService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import Pagination from "@/components/Common/Pagination.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import StatsOrder from "@/components/Common/StatsOrder.vue";
import Modal from "@/components/Common/Modal.vue";
import TargetCampaignHealthPanel from "@/components/Targets/TargetCampaignHealthPanel.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
      categories_jobs_group: (state) =>
        state.optionsList.all["category_jobs_group"].data,
    }),
    isOliverSale() {
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2
      );
    },
    isAdmin() {
      return this.currentUser && parseInt(this.currentUser.role_id, 10) === 1;
    },
    selectTabs() {
      if (this.hasPermissions("isAdminAgency")) {
        return this.adminTabs;
      }
      if (this.hasPermissions("billing")) {
        return this.billingTabs;
      }

      if (this.hasPermissions("sale") ) {
        return this.saleTabs;
      }
      return this.tabs;
    },
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
    
    allColumns() {
      // Combinar columnas básicas con columnas expandidas si están habilitadas
      const basicColumns = this.cols.filter(col => {
        const value = col[0] && col[0].value;
        // Excluir las últimas 6 columnas costosas de las columnas básicas
        return !['monthly_objective', 'total_task_todo', 'cold_meeting_rate', 'total_meetings_cold', 'total_cold_tasks_done'].includes(value) &&
               !(col[0] && col[0].type === 'imageSetMultipleLines' && col[0] && col[0].from === 'target');
      });
      
      if (this.expandedColumns) {
        return [...basicColumns, ...this.getExpandedColumns()];
      }
      
      return basicColumns;
    },
    
    allHeaders() {
      // Combinar headers básicos con headers expandidos si están habilitados
      const basicHeaders = this.headers.filter(header => {
        // Excluir los headers de las últimas 6 columnas costosas
        return !['First send email date', 'Monthly Objective', 'Bookers', 'Pending Tasks', 'Cold meeting rate', 'Meeting cold call', 'Cold tasks done'].includes(header.label);
      });
      
      if (this.expandedColumns) {
        const expandedHeaders = [
          { label: "First send email date", class: "overflowhide", id: 8 },
          { label: "Monthly Objective", class: "overflowhide", id: 8 },
          { label: "Bookers", class: "overflowhide", id: 8 },
          { label: "Pending Tasks", class: "overflowhide" },
          { label: "Cold meeting rate", class: "overflowhide" },
          { label: "Meeting cold call", class: "overflowhide" },
          { label: "Cold tasks done", class: "overflowhide" },
        ];
        return [...basicHeaders, ...expandedHeaders];
      }
      
      return basicHeaders;
    },
  },

  data() {
    return {
      bookerAvailable: false,
      expandedColumns: false, // Control de columnas expandidas
      firstLoadingPage: true,
      key: 232332,
      orderBy: "0",
      orderDirection: "desc",
      waitingchoise: false,
      language_id: 0,
      oliver_sale_id: "0",
      userOliverSale: ["0"],
      filterCategories: [],
      calculateStats: {
        total_meetings: 0,
        total_amount: 0,
        total_email_sent: 0,
        meeting_rate: 0,
        spam_gmail: 0,
        spam_ews: 0,
        global_margin: 0,
      },
      userOliverSales: [{ id: "0", label: "All" }],
      filters: [],
      campaignsColumns: [
        {
          name: this.$t("lang.column.client"),
          name_: "client",
          type: "string",
          field: "client.name",
        },
        {
          name: this.$t("lang.column.clientstatus"),
          name_: "client",
          field: "client.client_status_id",
          type: "list",
          list: [
            {
              id: "2",
              name: this.$t("lang.onBoarding.onboarding"),
            },
            {
              id: "9",
              name: this.$t("lang.label.validating"),
            },
            {
              id: "3",
              name: this.$t("lang.targets.active"),
            },
            {
              id: "4",
              name: this.$t("lang.label.active"),
            },
            {
              id: "5",
              name: this.$t("lang.appointments.standby"),
            },
            {
              id: "8",
              name: this.$t("lang.label.pendingdeleted"),
            },
            {
              id: "7",
              name: this.$t("lang.payment.Recovery"),
            },
            {
              id: "6",
              name: this.$t("lang.label.deleted"),
            },
          ],
        },
        // {
        //   name: this.$t("lang.onBoarding.commercial_in_charge"),
        //   name_: "target",
        //   type: "string",
        //   field: "CONCAT(uo.lastname, ', ', uo.name)",
        // },
        {
          name: this.$t("lang.token.order_name"),
          name_: "target",
          type: "string",
          field: "t.name",
        },
        {
          name: 'Active teams',
          name_: "active_teams",
          type: "number",
          field: "active_teams",
          having: true,
        },
        {
          name: '3D Average Sent',
          name_: "avg_sent_3d",
          type: "number",
          field: "avg_sent_3d",
          having: true,
        },
        {
          name: this.$t("lang.label.sales"),
          name_: "sales",
          type: "string",
          field: "sales",
          having: true,
        },
        {
          name: this.$t("lang.label.sequence_type"),
          name_: "status",
          type: "list",
          list: [
            {
              id: "1",
              name: this.$t("lang.label.customized"),
            },
            {
              id: "3",
              name: "Open AI",
            },
          ],
          field: "sequence_type",
        },
        {
          name: "Should call",
          name_: "should_call_target",
          type: "list",
          list: [
            {
              id: "1",
              name: "Yes",
            },
            {
              id: "0",
              name: "No",
            },
          ],
          field: "should_call_target",
        },
        {
          name: "Email AVG3",
          name_: "email_avg3_day",
          type: "number",
          field: "ts.email_avg3_day ",
        },
        {
          name: this.$t("lang.label.creationdate"),
          type: "date",
          field: "t.created",
        },
        {
          name: this.$t("lang.column.status"),
          name_: "status",
          type: "list",
          list: [
            {
              id: "1",
              name: "Preparation",
            },
            {
              id: "2",
              name: "Inactive",
            },
            {
              id: "3",
              name: "Draft",
            },
            {
              id: "4",
              name: "Running",
            },
            {
              id: "5",
              name: "Archived",
            },
          ],
          field: "t.target_status_id",
        },
        {
          name: this.$t("lang.label.language"),
          name_: "status",
          type: "list",
          list: [
            {
              id: "1",
              name: "French",
            },
            {
              id: "2",
              name: "English",
            },
            {
              id: "3",
              name: "Spanish",
            },
            {
              id: "4",
              name: "Italian",
            },
            {
              id: "5",
              name: "Portuguese",
            },
          ],
          field: "t.language_id",
        },
        {
          name: "Owner",
          name_: "target",
          type: "string",
          field: "CONCAT(u.name,CONCAT(' ',u.lastname))",
        },
        {
          name: "Subscription",
          name_: "client_subscription",
          type: "string",
          field: " IFNULL(pl.name, '') ",
        },
        {
          name: this.$t("lang.column.launch_date"),
          type: "date",
          field: "t.launch_date_campaign",
        },
        {
          name: this.$t("lang.column.preparingDays"),
          name_: "name",
          type: "number",
          field: " IFNULL(DATEDIFF(NOW(), t.preparation_date), 0)",
        },
        {
          name: "Bookers",
          name_: "total_b",
          type: "number",
          having: true,
          field: " IFNULL(COUNT(DISTINCT ubt.id), 0) ",
        },
        {
          name: "Warning Days",
          name_: "warning_days",
          type: "number",
          having: true,
          field:
            " IF(MIN(ow.start_on) IS NULL, 0, DATEDIFF(NOW(), MIN(ow.start_on)))",
        },
        {
          name: "Audience size",
          name_: "audience_size",
          type: "number",
          field: " CEIL(t.total_contacts / 1000)",
        },
        {
          name: "Global margin",
          name_: "global_margin",
          type: "number",
          having: true,
          field: " global_margin ",
        },
        {
          name: "SPCHK EWS",
          name_: "spam_check_ews",
          type: "number",
          field: "ts.spam_check_ews ",
        },
        {
          name: "SPCHK GML",
          name_: "spam_check_gmail",
          type: "number",
          field: "ts.spam_check_gmail ",
        },
        {
          name: this.$t("lang.column.updated"),
          type: "date",
          field: "t.updated",
        },
        {
          name: "Unique prospects",
          name_: "total_contacted_contacts",
          type: "number",
          field: "ts.total_contacted_contacts",
        },
        {
          name: "Sent emails",
          name_: "total_email_sent",
          type: "number",
          field: "ts.total_email_sent",
        },
        {
          name: "Meetings / unique prospects",
          name_: "meeting_rate",
          type: "number",
          field: "ts.meeting_rate",
        },
        {
          name: "Meetings",
          name_: "total_meetings",
          type: "number",
          field: "ts.total_meetings",
        },
        {
          name: "Spent",
          name_: "total_amount",
          type: "number",
          field: "ts.total_amount",
        },
        {
          name: "Warmup Active",
          name_: "warmup_active",
          field: "t.warmup_active",
          type: "list",
          list: [
            {
              id: "1",
              name: "ON",
            },
            {
              id: "0",
              name: "OFF",
            },
          ],
        },
        {
          name: this.$t("lang.column.create_mailboxes"),
          name_: "create_mailboxes",
          field: "t.create_mailboxes",
          type: "list",
          list: [
            {
              id: "1",
              name: "ON",
            },
            {
              id: "0",
              name: "OFF",
            },
          ],
        },
        {
          name: "Audience",
          name_: "audience",
          field: "t.audience",
          type: "list",
          list: [],
        },
        {
          name: "Audience description",
          name_: "Audience description",
          field: "t.audience_description",
          type: "list",
          list: [],
        },
        {
          name: "Links/No Links",
          name_: "has_links",
          field: "t.has_links",
          type: "list",
          list: [
            {
              id: "1",
              name: "Has Links",
            },
            {
              id: "0",
              name: "No links",
            },
          ],
        },
        {
          name: "Spintax/No Spintax",
          name_: "has_spintax",
          field: "t.has_spintax",
          type: "list",
          list: [
            {
              id: "1",
              name: "Has Spintax",
            },
            {
              id: "0",
              name: "No Spintax",
            },
          ],
        },
        {
          name: "New contact / day",
          name_: "new_emails_per_day",
          type: "number",
          field: "t.new_emails_per_day",
        },
        {
          name: "Total contacts / day",
          name_: "total_emails_per_day",
          type: "number",
          field: "t.total_emails_per_day",
        },
        {
          name: this.$t("lang.column.contact_source"),
          name_: "salesridge",
          field: "IF(t.salesridge IS NOT NULL AND t.version IS NULL,'1',IF(t.version = '2', '2', '0'))",
          type: "list",
          list: [
            {
              id: "1",
              name: "SalesRidge",
            },
            {
              id: "0",
              name: "Apollo",
            },
            {
              id: "2",
              name: "Full Enrich",
            },
          ],
        },
        {
          name: "Order Type",
          name_: "order_type",
          field: "t.order_type",
          type: "list",
          list: [
            {
              id: "acquisition",
              name: "acquisition",
            },
            {
              id: "activation",
              name: "activation",
            },
          ],
        }
      ],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      audience_items: [
        "SaaS Solutions (management software, ERP, CRM, etc.)",
        "Consulting Services (strategy, marketing, finance, human resources, etc.)",
        "Technology Equipment (IT equipment, servers, networks, etc.)",
        "Industrial Supplies (production equipment, machine tools, etc.)",
        "Professional Training (personal development, sales techniques, management, etc.)",
        "HR Services (recruitment, personnel outsourcing, talent management, etc.)",
        "Digital Marketing (advertising agencies, SEO/SEM optimization, social media management, etc.)",
        "Logistics and Transport (shipment management solutions, freight services, etc.)",
        "Financial Services (treasury management, banking services, insurance, etc.)",
        "Cybersecurity Solutions (risk management, data protection, etc.)",
        "Legal Services (compliance management, business law advice, etc.)",
        "Energy Services (energy audit, cost optimization, etc.)",
        "Office Equipment (furniture, office supplies, workspace solutions, etc.)",
        "IT Services (infrastructure management, cloud computing, IT maintenance, etc.)",
        "Healthcare Supplies and Equipment (medical equipment, teleconsultation services, etc.)",
      ],
      archived: false,
      total: undefined,
      // total_verified: [],
      // total_no_verified: [],
      resetFilterSystem: false,
      paginationkey: 9900,
      sort: "",
      dir: "",
      keyFilter: 1,
      filterSystem: {},
      searchFilter: {},
      oldQuery: "  ",
      listStatus: [
        {
          id: 2,
          name: this.$t("lang.label.nonverified"),
        },
        {
          id: 1,
          name: this.$t("lang.label.verified"),
        },
      ],
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      mainTabs: {
        1: {
          id: 1,
          name: "Parameters",
        },
        2: {
          id: 2,
          name: "History",
        },
      },
      adminTabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 3,
          name: this.$t("lang.targets.pending"),
        },
        3: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
        4: {
          id: 4,
          name: this.$t("lang.targets.running"),
        },
        5: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        6: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        99: {
          id: 99,
          name: "Cold Tasks Finished",
        },
      },
      tabPreparing: {
        7: {
          id: 6,
          name: this.$t("lang.button.all"),
        },
        8: {
          id: 7,
          name: this.$t("lang.label.unverified"),
        },
        9: {
          id: 8,
          name: this.$t("lang.refuse.refused"),
        },
        11: {
          id: 9,
          name: this.$t("lang.label.verified"),
        },
      },
      tabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        3: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        4: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
      },
      saleTabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        3: {
          id: 4,
          name: this.$t("lang.targets.running"),
        },
        4: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        5: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
      },
      billingTabs: {
        1: {
          id: 10,
          name: this.$t("lang.button.all"),
        },
        2: {
          id: 3,
          name: this.$t("lang.targets.pending"),
        },
        3: {
          id: 1,
          name: this.$t("lang.targets.active"),
        },
        4: {
          id: 4,
          name: this.$t("lang.targets.running"),
        },
        5: {
          id: 2,
          name: this.$t("lang.targets.stopped"),
        },
        6: {
          id: 5,
          name: this.$t("lang.onBoarding.archived_orders"),
        },
        // 6: {
        //   id: 6,
        //   name: this.$t("lang.label.verified")
        // },
        // 7: {
        //   id: 7,
        //   name: this.$t("lang.label.unverified")
        // },
        // 8: {
        //   id: 8,
        //   name: this.$t("lang.refuse.tab")
        // }
      },
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 100,
        currentPage: 1,
      },
      situationTarget: null,
      cols: [
        [
          {
            value: "id",
          },
          {
            type: "icon",
            icon_class: "icon-search text-dark",
            value_emit: "id",
            type2: "emit",
            emit: "openTargetSituation",
            button_title: "Campaign situation — click for details",
            adminOnly: true,
            neutralSituationIcon: true,
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value: "should_call_target",
            type: "status",
            icon_to_true: "icon-checkmark text-success",
            icon_to_false: "icon-remove text-danger",
          },
        ],
        [
          {
            value: "create_mailboxes",
            type: "status",
            icon_to_true: "icon-checkmark text-success",
            icon_to_false: "icon-remove text-danger",
          },
        ],
        [
          {
            value: "email_avg3_day",
            name: "email_avg3_day",
            type: "number",
            field: "email_avg3_day",
          },
        ],
        [
          {
            value: "langFlag",
            type: "image",
            hasTooltip: "language_name",
            isStatic: true,
          },
        ],
        [
          {
            value: "order_type",
          }
        ],
        [ 
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              // ...(condición ? [{ badge_if: "finished", ... }] : []) -> desempaqueto el array y evalua al llegar al 4to objeto si el role_id es el requerido para mostrar o no
              ...(
                this.$store.state.authentication.user.role_id != 4 &&
                this.$store.state.authentication.user.role_id != 3
              ? [{
                  badge_if: "finished",
                  badge_value: "1",
                  badge_class: "badge badge-danger text-white",
                  badge_label: "Cold finished",
                  badge_tooltip: "There are no more tasks left to generate",
                }]
              : []),
            ],
          },
        ],
        [
          {
            value1: "salesridge",
            value2: "version",
            format: 1,
            type: "twoValueParenthesis"
          }
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
            badges: [
              {
                badge_if: "client_status_id",
                badge_value: "2",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.onBoarding.onboarding"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },

              {
                badge_if: "client_status_id",
                badge_value: "9",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.validating"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "3",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.active"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-info text-white",
                badge_label: this.$t("lang.appointments.standby"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "8",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.pendingdeleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "7",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.payment.Recovery"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "6",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.deleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "41",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.monthlypaused"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "launch_date_campaign",
          }
        ],

        [
          {
            value: "sales",
            type: "peopleNames",
            from: "'target'",
          },
        ],
        [
          {
            value: "duplicate_reason",
            class: "text-center",
          },
        ],
        [
          {
            value: "target_size",
          },
        ],
        [
          {
            value: "days_since_accepted",
          },
        ],
        [
          {
            value: "id",
            type: "campaignsBadge",
            formatNumber: "true",
            loading: "true",
          },
        ],

        [
          {
            value: "id",
            type: "campaignsBadge",
            loading: "true",
          },
        ],
        [
          {
            value: "id",
            type: "targetProblem",
            small: true,
          },
        ],
        // [
        //   {
        //     value: "avg_sent_3d",
        //     class: "text-primary",
        //   },
        // ],
        [
          {
            value: "id",
            type: "statsBadge",
          },
        ],
        [
          {
            value: "subscription_data",
            type: "twoValues",
            value2: {
              value: "billing_status",
              show_text: "false",
              icons: [
                {
                  icon_if_value: "1",
                  icon_true: "icon-minus-circle text-danger icon-small",
                  tooltip_true: "DISABLED",
                },
                {
                  icon_if_value: "2",
                  icon_true: "icon-clock text-warning icon-small",
                  tooltip_true: "UNTIL TARGET RUNNING",
                },
                {
                  icon_if_value: "4",
                  icon_true: "icon-clock text-warning icon-small",
                  tooltip_true: "UNTIL KICKOFF + 30 DAYS",
                },
              ],
            },
          },
        ],

        [
          {
            value: "monthly_objective",
            class: "text-primary",
            type: "isAsync",
          },
        ],
        [
          {
            value: "id",
            type: "imageSetMultipleLines",
            from: "target",
          },
        ],
        [
          {
            value: "total_task_todo",
            type: "isAsync",
          },
        ],
        [
          {
            value: "cold_meeting_rate",
            class: "text-primary",
            format: "percentage",
            type: "isAsync",
          },
        ],
        [
          {
            value: "total_meetings_cold",
            class: "text-primary",
            type: "isAsync",
          },
        ],
        [
          {
            value: "total_cold_tasks_done",
            class: "text-primary",
            type: "isAsync",
          },
        ],
      ],
      headers: [
        {
          label: this.$t("lang.token.order_id"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 1,
        },
        {
          label: this.$t("lang.column.creation"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 1,
        },
        {
          label: "Account Manager",
          percentage: "12.5%",
          class: "",
          permission: "AgencyBillingOrSales",
          id: 4,
        },
        {
          label: "Should call",
          percentage: "12.5%",
          class: "",
          permission: "superAdmin",
          id: 4,
        },
        {
          label: this.$t("lang.column.create_mailboxes"),
          percentage: "12.5%",
          class: "",
          permission: "superAdmin",
          id: 4,
        },
        {
          label: "Email AVG3 days",
          percentage: "12.5%",
          class: "",
          permission: "superAdmin",
          id: 4,
        },
        {
          label: "Language",
          class: "overflowhide",
          id: 8,
        },
        {
          label: this.$t("lang.orders.order_type"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 1,
        },
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 1,
        },
        {
          label: this.$t("lang.column.contact_source"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "superAdmin",
          id: 1,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },

        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 2,
        },
        {
          label: this.$t("lang.column.launch_date"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 12,
        },
        {
          label: "Client outbound teams", //this.$t("lang.label.sales"),
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 4,
        },
        {
          label: this.$t("lang.label.sequence_type"),
          percentage: "12.5%",
          permission: "adminClients",
          class: "",
        },

        {
          label: this.$t("lang.label.portentialaudiencesize"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 7,
        },

        

        {
          label: "Days since accepted",
          percentage: "12.5%",
          class: "",
          id: 27,
          permission: "adminClients",
        },
        {
          label: "Emails", //this.$t("lang.label.prospectingemails"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },

        {
          label: this.$t("lang.label.campaigns"),
          percentage: "12.5%",
          class: "",
          id: 14,
          permission: "adminClients",
        },

        {
          label: this.$t("lang.column.utilization"),
          size: "280px",
          percentage: "280px",
          class: "utilization-column",
          permission: "adminClients",
          id: 23,
        },
        // {
        //   label: '3D Average Sent',
        //   percentage: "20%",
        //   permission: "adminClients",
        //   id: 33,
        // },

        {
          label: this.$t("lang.label.statistics") + ' (calculated at midnight)',
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 16,
        },
        {
          label: "Subscription",
          class: "overflowhide",
          permission: "adminClients",
          id: 17,
        },
        {
          label: "First send email date",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBillingOrSales",
          id: 12,
        },
        {
          label: "Monthly Objective",
          class: "overflowhide",
          id: 8,
        },
        {
          label: "Bookers",
          class: "overflowhide",
          id: 8,
        },
        {
          label: "Pending Tasks",
          class: "overflowhide",
        },
        {
          label: "Cold meeting rate",
          class: "overflowhide",
        },
        {
          label: "Meeting cold call",
          class: "overflowhide",
        },
        {
          label: "Cold tasks done",
          class: "overflowhide",
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Tabs,
    FilterSystem,
    Pagination,
    StatsOrder,
    IndustrySearch,
    Modal,
    TargetCampaignHealthPanel,
  },

  async created() {
    this.loading = true;
    if (!this.hasPermissions("adminClients")) {
      this.headers = this.headers.filter((header) => header.id != 5);
      this.cols = this.cols.filter((col) => col[0].value != "warmup_days");
    } else {
      // TODO: Tener encuenta, No cometer este error en otras vistas, Este endpoint al retornar permission denied para user billing rol_id =4 remueve el token y por end no redirecciona correctamente por q no encuentra dicho token
      if(!this.fromAtRiskAccounts){
        await this.getUserOliverSales();
      }      
    }
  },
  updated() {
    this.campaignsColumns.forEach((item) => {
      if (item.name == "audience") {
        item.list = [];
        this.categories_jobs_group.forEach((element) => {
          item.list.push({
            id: element.category,
            name: this.$t("lang.category_job_group." + element.category),
          });
        });
      }
      if (item.name == "Audience description") {
        item.list = [];
        this.audience_items.forEach((it) => {
          item.list.push({
            id: it,
            name: it,
          });
        });
      }
    });
  },
  mounted() {
    this.setHeader();
    if (this.$route.fullPath.includes("/orders-by-lang/")) {
      this.language_id = this.$route.params.id;
    }
    if (
      this.hasPermissions("adminClients") &&
      this.$route.name == "orders" &&
      this.currentUser.role_id == 1 &&
      !this.$route.fullPath.includes("/orders-by-lang/")
    ) {
      this.loading = false;
      this.waitingchoise = true;
      return;
    }

    this.removeColumn("adminClients", 5, "warmup_days");
    this.loadOrders(this.typelist, null, true);
    this.setHeader();
    this.filterColumn.push({
      name: "Status",
      type: "list",
      list: this.listStatus,
      field: "tv.status",
    });
  },

  watch: {
    "$route.fullPath"() {
      this.setHeader();
    },
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false,
    },
    fromAtRiskAccounts: {
      type: Boolean,
      default: false,
    },
    tab1: {
      type: Number,
      default: undefined,
    },
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    getAvailableContacts(data){        
      const availableContactsString = data.availableContacts.toString()
      const orderIndex = this.orders.findIndex(el => el.id == data.target_id);
      if(orderIndex !== -1){        
        this.$set(this.orders[orderIndex], 'lowest_available_contacts', availableContactsString);
      }      
    },
    isUserOliverSale() {
      const isRouteClient = this.$route.path.includes("/clients/")
        ? true
        : false;
      return (
        this.currentUser.role_id == 1 &&
        this.currentUser.user_constraint_id == 2 &&
        !isRouteClient
      );
    },
    updateOrder() {
      if(this.orderBy == '0') {
        this.loadOrders(this.orderStatus, this.filters);
        return;
      }

      this.orders = this.orders.slice().sort((a, b) => {
        let propA = a[this.orderBy] != null ? a[this.orderBy] : 0;
        let propB = b[this.orderBy] != null ? b[this.orderBy] : 0;

        let result = 0;

        // Convertir cadenas numéricas a números para comparación
        if (typeof propA === 'string' && !isNaN(propA)) {
          propA = Number(propA);
        }
        if (typeof propB === 'string' && !isNaN(propB)) {
          propB = Number(propB);
        }

        // Si la propiedad es un número (incluyendo casos como "0.00")
        if (!isNaN(propA) && !isNaN(propB)) {
          result = propA - propB;
        } else {
          // Si no son números, comparar como strings
          const strA = String(propA || '');
          const strB = String(propB || '');
          result = strA.localeCompare(strB);
        }

        if (propA === null || propA === undefined) propA = 0;
        if (propB === null || propB === undefined) propB = 0;

        // Manejo especial para "0", null o cadenas vacías
        if (
          (propA == 0 || propA === "" || propA === null) &&
          propB != 0 &&
          propB !== "" &&
          propB !== null
        ) {
          return this.orderDirection === "asc" ? -1 : 1;
        }
        if (
          (propB == 0 || propB === "" || propB === null) &&
          propA != 0 &&
          propA !== "" &&
          propA !== null
        ) {
          return this.orderDirection === "asc" ? 1 : -1;
        }

        // Si la ordenación es descendente, invertir el resultado
        if (this.orderDirection === "desc") {
          result = result * -1;
        }

        return result;
      });

      // Forzar actualización del componente Table cambiando la key
      this.captainkey++;
    },
    getUserOliverSales() {
      usersService
        .getUserOliverSales(true, 0, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            
            this.oliverSalesLoaded = true;
            this.userOliverSales.map((it) => {
              if (it.id == this.currentUser.id) {
                this.userOliverSaleId = it.id;
                this.userOliverSale = [it.id.toString()];
              }
            });
            this.key++;
          }
        })
        .catch((err) => console.error(err));
    },

    selectOliverSale(value) {
      const id = value && (value.id !== undefined ? value.id : value);
      this.userOliverSale = id != null && id !== "" ? [String(id)] : ["0"];
      this.loadOrders(this.orderStatus, this.filters);
    },
    formatSequenceType() {
      return "hola";
    },
    setHeader() {
      if(this.$route.fullPath == "/orders") {
        this.setCurrentRoute({ page: "all-orders", label: this.$t("lang.orders.orders") });
      }
      if(this.$route.fullPath.includes("/orders-by-lang/")) {
        switch (parseInt(this.$route.params.id)) {
          case 1:
            this.setCurrentRoute({ page: "orders-by-lang-fr", label: "Bookers France" });
            break;
          case 2:
            this.setCurrentRoute({ page: "orders-by-lang-en", label: "Bookers English" });
            break;
          case 4:
            this.setCurrentRoute({ page: "orders-by-lang-it", label: "Bookers Italy" });
            break;
          case 3:
            this.setCurrentRoute({ page: "orders-by-lang-esp", label: "Bookers Spain" });
            break;
        }
      }
    },
    getTittle(){
      if(this.$route.fullPath == "/orders") {
        return this.$t("lang.orders.orders");
      }
      if(this.$route.fullPath.includes("/orders-by-lang/")) {
        switch (parseInt(this.$route.params.id)) {
          case 1:
            return "Bookers France";
          case 2:
            return "Bookers English";
          case 4:
            return "Bookers Italy";
          case 3:
            return "Bookers Spain";
        }
      }
    },
    filterNow(filters) {
      this.filteredList = true;
      this.loading = true;
      this.searchFilter = filters;
      // this.model.searchFilter = this.searchFilter;
      // this.searchAgenciesSimple();
      // this.search();
    },
    removeColumn(permission, header_id, col_value) {
      if (!this.hasPermissions(permission)) {
        this.headers = this.headers.filter((h) => h.id != header_id);
        this.cols = this.cols.filter((col) => col[0].value != col_value);
      }
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    loadOrders(order, filter = [], created = null) {
      this.waitingchoise = false;

      this.getOrderNumber++;
      const subTabPreparaing = [6, 7, 8, 9];
      this.orders = [];
      this.loading = true;
      this.fieldsLoading = true;
      this.showEmptyImage = false;

      if (subTabPreparaing.includes(order)) {
        this.typelistPreparing = order;
      } else {
        this.typelist = order != undefined && order != NaN ? order : 10;
      }

      if (this.orderStatus != order) {
        this.model.currentPage = 1;
      }
      let filters = {
        currentPage: this.model.currentPage,
        cantPerPage: this.model.cantPerPage,
        filters: this.filters.filters ? this.filters.filters : null,
      };
      this.orderStatus = order;

      //this.showEmptyImage = true;
      let targets = [];
      if (order == 10 || order == 6) {
        targets = [1, 2, 3, 4];
      } else {
        targets = [order];
      }

      let data;

      if (this.language_id == 0) {
        data = {
          client_id: this.client_id,
          target_status_id: targets,
        };
      } else {
        data = {
          client_id: this.client_id,
          target_status_id: [4],
        };
      }

      data.searchFilter = filters;

      if (created) {
        data.oliver_sale = this.isOliverSale ? this.currentUser.id : undefined;
      } else {
        data.oliver_sale =
          this.userOliverSale[0] != "0"
            ? this.userOliverSale[0]
            : this.currentUser.id == 17
            ? undefined
            : this.currentUser.role_id == 4
            ? undefined
            : this.currentUser.id;
      }

      data.getOrderNumber = this.getOrderNumber;

      if (order == 3) {
        data.target_status_id = [3];
      }

      if (subTabPreparaing.includes(order)) {
        if (order == 6) {
          data.target_status_id = [1];
        }
        if (order == 9) {
          data.verified = true;
          data.target_status_id = [1];
        }
        if (order == 7) {
          data.unverified = true;
          data.target_status_id = [1];
        }
        if (order == 8) {
          data.refused = true;
          data.target_status_id = [1];
        }
      }

      if (order == 1) this.typelistPreparing = 6;

      if (this.isUserOliverSale()) {
        data.isUserOliverSale = true;
      }

      if(this.currentUser.role_id == 3){
        data.isUserOliverSale = false;
        data.oliver_sale = undefined;
      }

      if (order == 99) {
        data.finished_cold_tasks = 1;
        data.target_status_id = [4];
      }

      data.language_id = Number(this.language_id);

      if(this.fromAtRiskAccounts){
        data.target_status_id = [4]
      }

      targetsService.getTargetListByClientAndStatus(data).then((response) => {
        this.responseOrderNumber++;
        if (response !== undefined) {
          if (this.responseOrderNumber === response.getOrderNumber) {
            this.loading = false;
            this.calculateStats = response.stats;
            this.calculateStats.global_margin = parseFloat(
              this.calculateStats.global_margin
            ).toFixed(2);
            this.calculateStats.spam_check_ews = parseFloat(
              this.calculateStats.spam_check_ews
            ).toFixed(2);
            this.calculateStats.spam_check_gmail = parseFloat(
              this.calculateStats.spam_check_gmail
            ).toFixed(2);
            this.calculateStats.meeting_rate = parseFloat(
              this.calculateStats.meeting_rate
            ).toFixed(2);
            this.total = parseInt(response.total);
            // this.total_verified = response.total_verified;
            // this.total_no_verified = response.total_no_verified;
            if (this.total > 0) {
              this.ordersStatus = response.ordersStatus;
              //this.orders = response.orders;
              this.orders = response.orders.map((order) => {
                return {
                  ...order,
                  lowest_available_contacts: "0",
                  sequence_type: this.formatSequenceType(order.sequence_type),
                  sales: (order.sales && typeof order.sales === 'string')
                    ? order.sales.split("|").map((e) => e.trim())
                    : (Array.isArray(order.sales) ? order.sales : []),
                  langFlag: order.language_id,
                };
              });

              const targets = response.orders.map((target) => target.id);

              this.bookerAvailable = response.totalBookerWithoutOrders;

              // Solo cargar datos adicionales si las columnas están expandidas
              if (this.expandedColumns) {
                this.getAdditionalData(targets);
              }

              this.fieldsLoading = true;
              this.loadMoreInfoTarget();
              //this.calculateAllOrders();
            } else {
              this.showEmptyImage = true;
            }
          }
        }
      });
    },
    formatSequenceType(sequence_type) {
      let sequenceType = "";
      if (sequence_type == 1) sequenceType = this.$t("lang.label.customized");
      if (sequence_type == 2) sequenceType = "Template";
      if (sequence_type == 3) sequenceType = "Open AI";

      const sequence = [
        {
          label: sequenceType,
          value: sequenceType,
          class: "badge badge-success text-light",
          link: null,
          icon: "",
          tooltip: "",
        },
      ];
      return sequence;
    },

    getAdditionalData(targets) {
      clientsService.getColdMeetingRateByTarget(targets).then((response) => {
        this.orders.forEach((target) => {
          const monthly_objective = response.result.find(
            (el) => el.type == "monthly_objective" && el.target_id == target.id
          );

          if (monthly_objective) {
            target.monthly_objective = monthly_objective.total;
          } else {
            target.monthly_objective = 0;
          }

          const cold_meeting_rate = response.result.find(
            (el) => el.type == "cold_meeting_rate" && el.target_id == target.id
          );

          if (cold_meeting_rate) {
            target.cold_meeting_rate = cold_meeting_rate.total;
          } else {
            target.cold_meeting_rate = 0;
          }

          const total_meetings_cold = response.result.find(
            (el) =>
              el.type == "total_meetings_cold" && el.target_id == target.id
          );

          if (total_meetings_cold) {
            target.total_meetings_cold = Number(
              total_meetings_cold.total
            ).toFixed(0);
          } else {
            target.total_meetings_cold = 0;
          }

          const total_cold_tasks_done = response.result.find(
            (el) =>
              el.type == "total_cold_tasks_done" && el.target_id == target.id
          );

          if (total_cold_tasks_done) {
            target.total_cold_tasks_done = Number(
              total_cold_tasks_done.total
            ).toFixed(0);
          } else {
            target.total_cold_tasks_done = 0;
          }

          const projected_daily_cold_tasks = response.result.find(
            (el) =>
              el.type == "projected_daily_cold_tasks" &&
              el.target_id == target.id
          );

          if (projected_daily_cold_tasks && target.prospectors_active) {
            const result =
              target.prospectors_active *
              Number(projected_daily_cold_tasks.total);
            if (result != 0) {
              target.projected_daily_cold_tasks = target.prospectors_active
                ? (
                    target.prospectors_active *
                    Number(projected_daily_cold_tasks.total)
                  ).toFixed(2)
                : 0;
            } else {
              target.projected_daily_cold_tasks = 0;
            }
          } else {
            target.projected_daily_cold_tasks = 0;
          }

          const total_bookers = response.result.find(
            (el) => el.type == "total_bookers" && el.target_id == target.id
          );

          if (total_bookers) {
            target.total_bookers = total_bookers.total;
          } else {
            target.total_bookers = 0;
          }

          if (projected_daily_cold_tasks) {
            target.booker_adjustments =
              Math.ceil(Number(target.projected_daily_cold_tasks) / 85) -
              target.total_bookers;
          } else {
            target.booker_adjustments = 0;
          }

          const first_email = response.result.find(
            (el) => el.type == "first_email" && el.target_id == target.id
          );

          if (first_email) {
            target.first_email = first_email.total;
          } else {
            target.first_email = 0;
          }

          const total_task_todo = response.result.find(
            (el) => el.type == "total_task_todo" && el.target_id == target.id
          );

          if (total_task_todo) {
            target.total_task_todo = Number(total_task_todo.total).toFixed(0);
          } else {
            target.total_task_todo = 0;
          }

          const prospectors_warmingup_days = response.result.find(
            (el) =>
              el.type == "prospectors_warmingup_days" &&
              el.target_id == target.id
          );

          if (prospectors_warmingup_days) {
            //target.prospectors_warmingup_days = Number(prospectors_warmingup_days.total).toFixed(0);
            target.prospectors_warmingup =
              target.prospectors_warmingup +
              "(" +
              prospectors_warmingup_days.total +
              ")"; // Number(prospectors_warmingup_days.total).toFixed(0);
          } else {
            //              target.prospectors_warmingup_days = 0
          }
        });
      });
    },

    getExpandedColumns() {
      // Columnas que solo se cargan cuando se expande
      return [
        [
          {
            value: "first_email",
            type: "isAsync",
          },
        ],
        [
          {
            value: "monthly_objective",
            class: "text-primary",
            type: "isAsync",
          },
        ],
        [
          {
            value: "id",
            type: "imageSetMultipleLines",
            from: "target",
          },
        ],
        [
          {
            value: "total_task_todo",
            type: "isAsync",
          },
        ],
        [
          {
            value: "cold_meeting_rate",
            class: "text-primary",
            format: "percentage",
            type: "isAsync",
          },
        ],
        [
          {
            value: "total_meetings_cold",
            class: "text-primary",
            type: "isAsync",
          },
        ],
        [
          {
            value: "total_cold_tasks_done",
            class: "text-primary",
            type: "isAsync",
          },
        ],
      ];
    },

    toggleExpandedColumns() {
      this.expandedColumns = !this.expandedColumns;
      
      if (this.expandedColumns && this.firstLoadingPage) {
        // Cargar datos adicionales cuando se expande
        this.firstLoadingPage = false;
        this.loadAdditionalData();
      }
    },

    loadAdditionalData() {
      // Cargar datos adicionales solo cuando se necesiten
      const targets = this.orders.map(order => order.id);
      this.getAdditionalData(targets);
    },

    // loadArchivedOrders() {
    //   this.archived = true;
    //   this.loading = true;
    //   this.showEmptyImage = false;
    //   let data = {
    //     client_id: this.client_id,
    //     target_status_id: 5,
    //   };
    //   targetsService.getTargetListByClientAndStatus(data).then((response) => {
    //     if (response !== undefined) {
    //       this.orders = response;
    //       if (this.orders.length == 0) this.showEmptyImage = true;
    //       this.loading = false;
    //     }
    //   });
    // },

    editOrder(index) {
      this.$router.push("/orders/" + index);
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },

    addOrder(index) {
      this.$router.push("/orders/add");
    },
    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openTargetSituation(targetId) {
      if (!this.isAdmin) {
        return;
      }
      const row = this.orders.find(
        (order) => String(order.id) === String(targetId)
      );
      if (!row) {
        return;
      }
      this.situationTarget = {
        target_id: row.id,
        target_name: row.target_name || row.name,
      };
      this.$modal.show("target-situation-modal");
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    openWebsite(website) {
      let url;
      if (!website.includes("https://")) {
        url = "https://" + website;
      } else {
        url = website;
      }
      window.open(url, "_blank");
    },
    changePage() {
      this.loading = true;
      this.expandedColumns = false;
      this.firstLoadingPage = true;
      if (this.model.searchFilter) {
        this.searchAgenciesSimple();
      } else {
        this.loadOrders(this.orderStatus);
      }
    },

    loadMoreInfoTarget() {
      let neworders = [];
      let newItem = [];

      this.orders.forEach(async (item) => {
        item.created = item.created.substr(0, 10);
        item.updated = item.updated.substr(0, 10);
        if (item.launch_date_campaign) {
          item.launch_date_campaign = item.launch_date_campaign.substr(0, 10);
        }

        if (item.target_size && item.target_size_used) {
          item.audience_usage =
            ((item.target_size_used * 100) / item.target_size)
              .toFixed(0)
              .toString() + "%";
        } else {
          item.audience_usage = 0;
        }

        if (!item.target_size) {
          item.target_size = 0;
        } else {
          if (item.target_size > 1000) {
            item.target_size = Math.ceil(item.target_size / 1000) + " K";
          }
        }
        // const resp = await usersService.getSales(item.id).then(async (res) => {
        //   let contacted;
        //   let allSales = [];
        //   res.forEach((sale) => {
        //     if (item.id == sale.target_id) {
        //       let saleName = "";
        //       saleName =
        //         sale.first_name +
        //         " " +
        //         sale.last_name +
        //         " (" +
        //         sale.email +
        //         ")";
        //       allSales.push(saleName);
        //     }
        //   });

        // newItem = Object.assign({}, item, {
        //   sales: allSales.join("  /  "),
        // });

        newItem = Object.assign({}, item);
        neworders.push(newItem);

        //   // const resp2 = await targetsService.getContactedOrder(item.id)
        //   //   .then(r => {
        //   //     contacted = r.total_contacts;
        //   //     newItem = Object.assign({}, item, {
        //   //       sales: allSales.join("  /  "),
        //   //       contacted: contacted
        //   //     });
        //   //     neworders.push(newItem);
        //   //   });
        // });
      });
      // this.loading = true;
      this.orders = neworders;

      setTimeout(() => {
        this.fieldsLoading = false;
        // console.log("Fin Orders");
      }, 5000);
      // this.loading = false;
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}

.column-sales {
  width: 1200px !important;
  white-space: nowrap;
}

/* Embeddido en AgencyForm (/clients/:id): menús alineados a la derecha del toggle
   invaden la columna de tabs; anclar a la izquierda y subir z-index. */
.orders-filter-embedded-client >>> #filterSystem .dropdown-menu.dropdown-menu-right {
  left: 0 !important;
  right: auto !important;
  margin-left: 0.25rem;
}

.orders-filter-embedded-client >>> #filterSystem .dropdown-menu {
  z-index: 1060;
}
</style>
